export default __webpack_public_path__ + "static/media/1.43478bc1.jpg";